import React from 'react';
import { Heart, Users, HandHeart } from 'lucide-react';

const RoleSelection = ({ onSelect, onBack }) => (
  <div className="min-h-screen flex items-center justify-center px-5 py-10" data-testid="role-selection">
    <div className="max-w-sm w-full fade-in">
      <div className="text-center mb-8">
        <div className="relative w-14 h-14 flex items-center justify-center mx-auto mb-4">
          <div className="absolute inset-0 rounded-full border-2 border-cyan-300/40" />
          <div className="absolute inset-2 rounded-full border-2 border-cyan-400/60" />
          <div className="w-7 h-7 bg-red-500 rounded-full flex items-center justify-center">
            <Heart className="w-3.5 h-3.5 text-white" fill="currentColor" />
          </div>
        </div>
        <h2 className="text-2xl font-bold text-foreground" style={{ fontFamily: 'Outfit, sans-serif' }}>Welcome to CircleUpSquad</h2>
        <p className="text-sm text-muted-foreground mt-1">How are you joining?</p>
      </div>

      <div className="space-y-3">
        <button data-testid="role-patient-btn" onClick={() => onSelect('patient')} className="surface-card-hover w-full p-6 text-left group">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-cyan-100 dark:bg-cyan-900/30 rounded-xl flex items-center justify-center group-hover:bg-cyan-200 dark:group-hover:bg-cyan-900/50 transition-colors flex-shrink-0">
              <Heart className="w-6 h-6 text-cyan-600" />
            </div>
            <div>
              <h3 className="text-base font-semibold text-foreground" style={{ fontFamily: 'Outfit, sans-serif' }}>I need support</h3>
              <p className="text-xs text-muted-foreground mt-0.5">Create your care circle and invite your support team</p>
            </div>
          </div>
        </button>

        <button data-testid="role-care-coordinator-btn" onClick={() => onSelect('care_coordinator')} className="surface-card-hover w-full p-6 text-left group">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-purple-100 dark:bg-purple-900/30 rounded-xl flex items-center justify-center group-hover:bg-purple-200 dark:group-hover:bg-purple-900/50 transition-colors flex-shrink-0">
              <HandHeart className="w-6 h-6 text-purple-600" />
            </div>
            <div>
              <h3 className="text-base font-semibold text-foreground" style={{ fontFamily: 'Outfit, sans-serif' }}>{"I'm coordinating care for someone"}</h3>
              <p className="text-xs text-muted-foreground mt-0.5">Set up a circle for a loved one — invite their people, share updates, keep everyone aligned</p>
            </div>
          </div>
        </button>

        <button data-testid="role-care-partner-btn" onClick={() => onSelect('care_partner')} className="surface-card-hover w-full p-6 text-left group">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-amber-100 dark:bg-amber-900/30 rounded-xl flex items-center justify-center group-hover:bg-amber-200 dark:group-hover:bg-amber-900/50 transition-colors flex-shrink-0">
              <Users className="w-6 h-6 text-amber-700 dark:text-amber-400" />
            </div>
            <div>
              <h3 className="text-base font-semibold text-foreground" style={{ fontFamily: 'Outfit, sans-serif' }}>I was invited</h3>
              <p className="text-xs text-muted-foreground mt-0.5">Join someone{"'"}s care circle as a supporter</p>
            </div>
          </div>
        </button>
      </div>

      <div className="text-center mt-4">
        <button onClick={onBack} className="text-sm text-muted-foreground hover:text-foreground transition-colors">Back</button>
      </div>
    </div>
  </div>
);

export default RoleSelection;
